import React from 'react'
import { Pressable } from 'react-native'

import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'
import { Text } from 'widgets/Text'

export const UpscoreBadge = ({
  showOutline = true,
  text,
  onPress,
}: {
  showOutline?: boolean
  text: string
  onPress?: () => void
}) => {
  return (
    <Box testID='UpscoreBadgeContainer' height={36} width={36} borderRadius='lg'>
      <Pressable onPress={onPress && onPress}>
        <Box align='center'>
          <Icon
            name={showOutline ? 'small-gradient-circle-with-outline' : 'small-gradient-circle'}
            color='white'
            size={32}
          />
          <Box position='absolute' margin={{ top: 5 }}>
            <Icon name='upscore' color='white' size={10} />
          </Box>
          <Box position='absolute' margin={{ top: 13 }}>
            <Text bold color='white' fontSize='xs'>
              {text}
            </Text>
          </Box>
        </Box>
      </Pressable>
    </Box>
  )
}
